export const LOCKABLE_PAGE_ROOT_SELECTOR = 'body';
